import {
  Box,
  Button,
  Container,
  FormField,
  Grid,
  Header,
  Icon,
  Input,
  Modal,
  Multiselect,
  SpaceBetween,
  Spinner,
  TextContent
} from '@cloudscape-design/components';
import { DocumentContext } from '../../context/documentContext';
import { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DocumentViewerFiltered } from '../FilteredDocumentViewer';
import { TopicOverview } from './TopicOverview';
import { DocumentViewer } from '../DocumentViewer';
import { KnowledgeBaseModal } from './KnowledgeBaseModal';
import { OptionDefinition } from '@cloudscape-design/components/internal/components/option/interfaces';
import { OwnershipOverview } from './OwnershipOverview';
import { kbSentenceItem } from '../../models/interfaces';
import { BaseKeyDetail } from '@cloudscape-design/components/internal/events';
import { ReportsView } from './reportsView';

const filterList = [
  {
    label: 'Organization',
    value: 'Organization'
  },
  {
    label: 'Customer',
    value: 'Customer'
  },
  {
    label: 'Vendor',
    value: 'Vendor'
  },
  {
    label: 'Regulations',
    value: 'Regulations'
  },
  {
    label: 'Standards',
    value: 'Standards'
  },
  {
    label: 'OSHA',
    value: 'OSHA'
  }
];
export const BaseLayout = () => {
  const {
    setCurrentDocId,
    showModal,
    setShowModal,
    setSelectedItems,
    selectedItems,
    localSelectedItems,
    addKBsentences,
    setSelectedItemsKbResults,
    freeHandleAnalyze,
    setKbLoading,
    updateSentenceLoading,
    kbFilterOptions
  } = useContext(DocumentContext);
  const [queryParameters] = useSearchParams();
  const [showDetail, setShowDetail] = useState<boolean>(false);
  const [pageType, setPageType] = useState<string>('');
  const [showOverview, setShowOverview] = useState<boolean>(false);
  const [showAttribution, setShowAttribution] = useState<boolean>(false);
  const [showEntireDocument, setShowEntireDocument] = useState<boolean>(false);
  const [selectedFilterOption, setSelectedFilterOption] = useState<
    OptionDefinition[]
  >([]);
  const [text, setText] = useState<string>('');
  const [localFilterOptions, setLocalFilterOptions] = useState<
    OptionDefinition[]
  >([]);

  useEffect(() => {
    if (queryParameters.get('documentId')) {
      console.log('query ', queryParameters.get('documentId'));
      setCurrentDocId(queryParameters.get('documentId')!);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParameters]);

  useEffect(() => {
    setSelectedFilterOption([...kbFilterOptions]);
    setLocalFilterOptions([...kbFilterOptions]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kbFilterOptions]);

  const setShowPage = (view: string) => {
    setShowDetail(true);
    setPageType(view);
  };
  const setShowSynopsis = () => {
    setShowDetail(false);
    setShowEntireDocument(false);
    setShowAttribution(false);
    setPageType('');
    setShowOverview(false);
  };
  useEffect(() => {
    setSelectedItems([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageType, showOverview, showEntireDocument, showDetail]);

  const addSentencesToReport = async (close: boolean) => {
    const sentenceIds = localSelectedItems.map((ele) => ele._id);
    addKBsentences(sentenceIds, close);
  };

  const handleSearch = async () => {
    try {
      setKbLoading(true);
      const originalKBItems = localSelectedItems.map((ele) => ele._id);
      const result = await freeHandleAnalyze(text);
      const resultExlDups = result.filter(
        (ele: kbSentenceItem) => !originalKBItems.includes(ele._id)
      );
      setSelectedItemsKbResults([...resultExlDups, ...localSelectedItems]);
      setKbLoading(false);
    } catch (e) {
      console.log('error from freehand search');
    }
  };

  function handleKeyDown(event: CustomEvent<BaseKeyDetail>): void {
    console.log('event from input', event);
    if (event.detail.key === 'Enter') {
      handleSearch();
    }
  }

  return (
    <div>
      {!showDetail &&
      !showOverview &&
      !showEntireDocument &&
      !showAttribution ? (
        <div
          style={{
            height: '90vh',
            overflowY: 'scroll',
            scrollbarWidth: 'none',
            width: '100%'
          }}
        >
          <SpaceBetween size="l" direction="vertical">
            <Container
              header={
                <Header>
                  {/* <SpaceBetween direction="vertical" size="xxs"> */}
                  <>
                    <h1>Document Synopsis</h1>
                    <h6 style={{ margin: '0 0' }}>
                      Obligations, potential negotiation points, and important
                      information discovered in the analyzed document.
                    </h6>
                  </>
                  {/* </SpaceBetween> */}
                </Header>
              }
            >
              <SpaceBetween direction="vertical" size="s">
                <Box textAlign="center">
                  <Button onClick={() => setShowEntireDocument(true)}>
                    Entire Document
                  </Button>
                </Box>
                <Grid
                  gridDefinition={[
                    { colspan: { default: 4, m: 4 } },
                    { colspan: { default: 4, m: 4 } },
                    { colspan: { default: 4, m: 4 } }
                  ]}
                >
                  <Container
                    fitHeight
                    header={<Header>Obligations & Expectations</Header>}
                  >
                    <SpaceBetween size={'xl'} alignItems="center">
                      {/* <Button
                        onClick={() => {
                          setShowDetail(true);
                          setPageType('general-obligation');
                        }}
                      >
                        General Obligations
                      </Button> */}
                      <Button onClick={() => setShowOverview(true)}>
                        Construction Obligations
                      </Button>
                      {/* <Button
                      onClick={() => {
                        setShowDetail(true);
                        setPageType('privacy');
                      }}
                    >
                      Privacy Obligations
                    </Button> */}
                      {/* <Button
                        onClick={() => {
                          setShowAttribution(true);
                        }}
                      >
                        Burden Assignment
                      </Button> */}
                    </SpaceBetween>
                  </Container>
                  <Container
                    fitHeight
                    header={<Header>Negotiation Areas</Header>}
                  >
                    <SpaceBetween size={'xl'} alignItems="center">
                      <Button onClick={() => setShowPage('service')}>
                        Service level requirements
                      </Button>
                      <Button onClick={() => setShowPage('dates')}>
                        Obligations due dates
                      </Button>
                    <Button
                        onClick={() => {
                          setShowAttribution(true);
                        }}
                      >
                        Burden Assignment
                      </Button>
                    </SpaceBetween>
                  </Container>
                  <Container
                    header={<Header>Important Information</Header>}
                    fitHeight
                  >
                    <SpaceBetween size={'xl'} alignItems="center">
                      <Button onClick={() => setShowPage('financial')}>
                        Financial Information
                      </Button>
                      <Button onClick={() => setShowPage('people')}>
                        People, Roles & Responsibilities
                      </Button>
                      <Button onClick={() => setShowPage('places')}>
                        Places and Locations
                      </Button>
                    </SpaceBetween>
                  </Container>
                </Grid>
              </SpaceBetween>
            </Container>
            <ReportsView />
          </SpaceBetween>
        </div>
      ) : null}
      {showOverview ? (
        <TopicOverview
          setShowOverview={setShowOverview}
          setPageType={setPageType}
          setShowDetail={setShowDetail}
          setShowSynopsis={setShowSynopsis}
        />
      ) : null}
      {showAttribution ? (
        <OwnershipOverview
          setShowOverview={setShowAttribution}
          setPageType={setPageType}
          setShowDetail={setShowDetail}
          setShowSynopsis={setShowSynopsis}
        />
      ) : null}
      {showDetail ? (
        <DocumentViewerFiltered
          pageIdentifier={pageType}
          setShowSynopsis={setShowSynopsis}
        />
      ) : null}
      {showEntireDocument ? (
        <DocumentViewer setShowSynopsis={setShowSynopsis} />
      ) : null}
      {showModal ? (
        <Modal
          visible={showModal}
          size="max"
          onDismiss={() => {
            setShowModal(false);
            setText('');
          }}
        >
          <Container
            header={
              <Header
                actions={
                  <SpaceBetween size={'s'} direction="horizontal">
                    <Button
                      loading={updateSentenceLoading}
                      onClick={() => addSentencesToReport(false)}
                    >
                      Save Pinned
                    </Button>
                    <Button
                      onClick={() => {
                        addSentencesToReport(true);
                        setText('');
                      }}
                    >
                      Save and Close
                    </Button>
                  </SpaceBetween>
                }
              >
                <TextContent>
                  <h3>Knowledge Base Results</h3>
                </TextContent>
              </Header>
            }
          >
            <SpaceBetween size={'l'} direction="vertical">
              <TextContent>
                <p style={{ fontStyle: 'italic' }}>{selectedItems[0].text}</p>
              </TextContent>
              <Multiselect
                placeholder="Please select filter criteria"
                selectedOptions={selectedFilterOption}
                options={kbFilterOptions}
                onChange={({ detail }) => {
                  console.log('dtail', detail);
                  setSelectedFilterOption([...detail.selectedOptions]);
                }}
              />
              <>
                <FormField
                  stretch
                  description="Search the knowledge base to find answers"
                  label="Enter a Question"
                >
                  <Input
                    value={text}
                    type="search"
                    onChange={(event) => setText(event.detail.value)}
                    onKeyDown={(event) => handleKeyDown(event)}
                  />
                </FormField>
              </>

              <div style={{ height: '60vh', overflow: 'scroll' }}>
                <KnowledgeBaseModal filterType={selectedFilterOption} />
              </div>
            </SpaceBetween>
          </Container>
        </Modal>
      ) : null}
    </div>
  );
};
